import alterar from '@/core/store/item-ata/alterar-classificacao/alterar'
import historico from '@/core/store/item-ata/alterar-classificacao/historico'

export default {
	modules: {
		alterar,
		historico,
	},
}
